





















import Vue from 'vue';
import Toast from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'ApiKeyDisplayModal',
  props: {
    apiKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copyButtonText: 'Copy to Clipboard',
      copyButtonDisabled: false
    };
  },
  methods: {
    async copyToClipboard(this: any) {
      try {
        await navigator.clipboard.writeText(this.apiKey);
        this.copyButtonDisabled = true;
        this.copyButtonText = 'Copied!';
        Toast.showSuccess('API key copied to clipboard!');

        // Reset button after 2 seconds
        setTimeout(() => {
          this.copyButtonDisabled = false;
          this.copyButtonText = 'Copy to Clipboard';
        }, 2000);
      } catch (error) {
        Toast.showError('Failed to copy to clipboard. Please copy manually.');
      }
    }
  }
});
